import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import ForgotContainer from './ForgotContainer';

const ForgotPageContainer = () => {
  const navigate = useNavigate();

  const onSuccess = useCallback(() => {
    navigate('/login');
  }, [navigate]);

  return <ForgotContainer onSuccess={onSuccess} />;
};

ForgotPageContainer.displayName = 'ForgotPageContainer';

export default ForgotPageContainer;
